import { z } from "zod";

export const formSchema = z.object({
	Name: z.string().optional(),
	Email: z.string().email("Please enter a valid email address"),
	Phone: z.string().optional(),
	Message: z.string().optional(),
	ChannelUrl: z.string().optional(),
});

export type FormSchemaType = z.infer<typeof formSchema>;

export interface FormSubmitResult {
	success: boolean;
	error?: string;
	data?: unknown;
}
